import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import Calendar from 'react-calendar';
import moment from "moment";

export const CalenderDropdown = ({ handleChange, fromDate, handleFromDate, toDate, handleToDate, handlePreviousDateChange, previousDateShownFlag, isSingleDate, ...props }) => {
    const dispatch = useDispatch();
    const dropdownRef = useRef(null);

    const handleCheckboxChange = () => {
        handlePreviousDateChange(!previousDateShownFlag);
    };

    const [open, setOpen] = useState(false);

    const calendarClass = (moment(fromDate).format("YYYY-MM-DD") !== (moment(toDate).format("YYYY-MM-DD"))) ? 'main-claas-for-calendar-content' : 'main-claas-for-calendar-content-1';

    useEffect(() => {
        dispatch(isDropdownOpenFlag(open));
    }, [open]);

    const handleFromDateChange = (date) => {
        handleFromDate(date);
    };

    const handleToDateChange = (date) => {
        handleToDate(date);
    };

    const onButton = () => {
        {
            setOpen((prevOpen) => !prevOpen);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <div ref={dropdownRef}>
                <div className="text-white">
                    <div className="wrapper mt-3 mt-sm-0 mx-auto">
                        <div className="header-div d-flex flex-row justify-content-between" onClick={() => onButton()}>
                            <span>{moment(fromDate).format("DD-MMM-YYYY")} {moment(fromDate).format("YYYY-MM-DD") !== (moment(toDate).format("YYYY-MM-DD")) && previousDateShownFlag ? "TO" : ""} <br />
                                {moment(fromDate).format("YYYY-MM-DD") !== (moment(toDate).format("YYYY-MM-DD")) && previousDateShownFlag &&
                                    <span>{moment(toDate).format("DD-MMM-YYYY")}</span>
                                }
                            </span>
                            {open ? (
                                <span>
                                    <i className="bi bi-chevron-up chevron-up-arrow"></i>
                                </span>
                            ) : (
                                <span>
                                    <i className="bi bi-chevron-down chevron-down-arrow"></i>
                                </span>
                            )}

                        </div>
                        {open &&
                            (
                                <>
                                    <div id={calendarClass} className="calendar-dropdown-content">
                                        <span className="select-date-dropdown-text-style ms-2">Select Date</span>
                                        <div className="calendar-container" style={{ maxWidth: "215px" }}>
                                            <Calendar className="new-calender-class" onChange={(date) => handleFromDateChange(date)} value={fromDate} />
                                        </div>
                                        {!isSingleDate && <div>
                                            <input type="checkbox" id="checkbox" onChange={handleCheckboxChange} checked={previousDateShownFlag} />
                                            <label className="ms-2 select-date-dropdown-text-style" style={{ position: "inherit" }} htmlFor="checkbox">View period until </label>
                                        </div>}
                                        {
                                            previousDateShownFlag && (
                                                <>
                                                    <div className="calendar-container" style={{ maxWidth: "215px" }}>
                                                        <Calendar className="new-calender-class" onChange={(date) => handleToDateChange(date)} value={toDate} />
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                </>
                            )}
                    </div>
                </div>
            </div>

        </>
    );
};